import React from 'react';
import { Typography } from '../../../../shared/ui/typography/typography';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { Wrapper, ButtonWrapper } from './head.styles';
import { Button } from '@vtbhome/juicyfront';
import { HeadProps } from './types';
import { pageTitleType } from '@pages/product-page/lib/utils/page-title-type/page-title-type';

export const Head: React.FC<HeadProps> = ({ product }) => {
    const history = useHistory();

    return (
        <Wrapper>
            {Boolean(history.length) && (
                <ButtonWrapper>
                    <Button
                        round
                        size='xl'
                        buttonType='secondary'
                        startAdornment={<ArrowsChevronLeft />}
                        onClick={() => history.goBack()}
                    />
                </ButtonWrapper>
            )}
            <Typography size='h4'>Страница {pageTitleType(product)}</Typography>
            {/* <Tag variant='green'>Приобретено</Tag>
            <Tag variant='yellow'>Ожидает оплаты</Tag>
            <Tag
                variant='declined'
                declineMessage={{
                    managerAvatarUrl: 'https://i.pinimg.com/originals/de/d2/6e/ded26e0fd71f1c9909356224b31f897a.png',
                    managerName: 'Федоров Никита Cергеевич',
                    message: `"Здесь может быть краткое описание причины, по которой заявка была отклонена менеджером"`,
                }}>
                Отклонено
            </Tag> */}
        </Wrapper>
    );
};
